// extracted by mini-css-extract-plugin
export default {"container":"game_container__3Dm12","inner":"game_inner__3F7or","draw-path":"game_draw-path__39vUt"};